import React from 'react';
import { useSelector } from 'react-redux';
import { Content, IdentityPageContainer, IframeContainer, Title } from './styles';
import { IDENTITY_PAGE, JUMIO_RFI_PAGE, Screens } from './utils';
import { CHEVRON_LEFT_ICON } from '@Images';
import { JumioRFIPageProps } from './types';
import { getCountryCode, getNationality, getRfiCmsData } from '@Redux/selectors';
import { EU_REGION, MY } from '@Utils/constants';
import { getContentCountryCode } from '../user-flow/individual/revampedUserFlow/utils/Util';
import { getConditionalNote } from '@Utils/library';

const JumioRFIPage: React.FC<JumioRFIPageProps> = (props) => {
  const { iframeURL, jumioStatus, countryCodeFromJumio, changeScreen } = props;
  const jumioRFIPage = useSelector(getRfiCmsData)?.ekycRFI?.jumioRFIPage;
  const identityPageCMSData = useSelector(getRfiCmsData)?.ekycRFI?.identityPage;
  const { docList } = identityPageCMSData ?? IDENTITY_PAGE;
  const { myNational, nonMyNational } = jumioRFIPage || JUMIO_RFI_PAGE;
  const countryCode = useSelector(getCountryCode);
  const contentCountryCode = getContentCountryCode(countryCode);
  const ekycData = docList?.[contentCountryCode] ?? {};
  const nationality = useSelector(getNationality);

  const handleBackNavigation = () => {
    changeScreen(Screens.identityCheck);
  };

  const getUploadMsgEURegion = () => {
    const message = getConditionalNote(ekycData, countryCode, nationality);
    return `${message} ${ekycData?.checkPoint?.note2}`;
  };

  const getUploadMsg = () => {
    if (countryCode === MY && countryCodeFromJumio === 'MYS') return myNational;
    if (EU_REGION.includes(countryCode)) return getUploadMsgEURegion();
    return nonMyNational;
  };

  return (
    <IdentityPageContainer>
      <div className="navigationContainer">
        <img
          className="backButton"
          onClick={handleBackNavigation}
          src={CHEVRON_LEFT_ICON}
          alt="back"
        />
      </div>

      <div className="mainContainer">
        {iframeURL && jumioStatus !== 'success' && (
          <>
            <Title>Upload your ID document</Title>
            <Content>{getUploadMsg()}</Content>
            <Content className="jumioMsg">
              The images must be in JPG or PNG format and must not exceed 5 MB, PDF files are not
              accepted.
            </Content>
          </>
        )}
      </div>
      {iframeURL && jumioStatus !== 'success' && (
        <IframeContainer>
          <iframe
            allow="camera;fullscreen;accelerometer;gyroscope;magnetometer"
            title="Jumio Verification Iframe"
            src={iframeURL}
          />
        </IframeContainer>
      )}
    </IdentityPageContainer>
  );
};

export default JumioRFIPage;
